export default __webpack_public_path__ + "static/media/dressup.6283b176.png";